/**
 * Legacy PosApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.posApi`) keep resolving.
 *
 * The actual PosApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/pos/pos-api.service.ts
 */
angular.module("acme.common.service.posApi", [
  "acme.common.factory.QueryStringBuilder",
]);
